import React from 'react';
import { Container, Segment, Header, Button, List, Icon, Label, Message } from 'semantic-ui-react';
import moment from 'moment-timezone';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectCurrentViewWithData } from '../../redux/view/view.selectors';
import { setCurrentView } from '../../redux/view/view.actions';
import { getShiftsStart } from '../../redux/shifts/shifts.actions';
import { selectCurrentShifts, selectShiftsLoading, selectShiftsErrors } from '../../redux/shifts/shifts.selectors';
import { selectCurrentCompany } from '../../redux/company/company.selectors';

import { selectSurveysLoading, selectCurrentSurveys, selectSurveysErrors, selectCurrentPrompts, selectCurrentResponses } from '../../redux/surveys/surveys.selectors';
import { toggleSurveyStart, getSurveysStart, manualSurveyStart, getPromptsStart } from '../../redux/surveys/surveys.actions';

class ResponseList extends React.Component {

  componentDidMount() {
    const { currentCompany, getShiftsStart, getPromptsStart } = this.props;
    getShiftsStart({ currentCompany });
    getPromptsStart();
  }

  buildTemplateShiftKey = (templateId, shiftId) => {
    return `${templateId}--${shiftId}`;
  }

  toggleScheduledSurvey = (templateId, shiftId, nextStatus) => {
    const { toggleSurveyStart } = this.props;
    toggleSurveyStart({ templateId, shiftId, nextStatus });
  }

  renderShiftSublist = (shiftList) => {
    const { surveysLoading, manualSurveyStart, currentSurveys, currentPrompts, setCurrentView } = this.props;
    const shiftIds = Object.keys(shiftList);
    const templateId = "covid-19-survey";
    let surveyIds = [];
    if (currentSurveys) surveyIds = Object.keys(currentSurveys);
    return (
      <List divided relaxed verticalAlign='middle' animated size="large">
        { surveyIds.map(surveyId => {
          const shiftId = currentSurveys[surveyId].linkedShift;
          const promptId = currentSurveys[surveyId].lastPromptId;
          if (!promptId) return null;
          const promptType = currentSurveys[surveyId].lastPromptType;
          const promptTime = currentSurveys[surveyId].lastPromptedTime;
          const isScheduled = currentSurveys[surveyId].isEnabled;
          if (!currentPrompts) return null;
          const lastPrompt = currentPrompts[promptId];
          if (!lastPrompt) return null;
          const noResponse = lastPrompt.notifiedEmployeeIds || [];
          const clearedForWork = lastPrompt.clearedForWork || [];
          const atRisk = lastPrompt.employeesAtRisk || [];
          return (
            <List.Item key={surveyId}>
              <List.Content floated='right'>
                <Button primary style={{ position: 'relative' }} onClick={() => setCurrentView("ResponseView", { promptId: promptId, promptTime: promptTime, promptType: promptType })}>View Responses
                {/* <Label circular color="red" className="buttonCircleNotification">9</Label> */}
                </Button>
              </List.Content>
              {/* <List.Content floated='right'>
              { surveysLoading ? (<Icon loading name='spinner' />) : (
                <React.Fragment>
                <Button 
                  onClick={() => this.toggleScheduledSurvey(templateId, shiftId, !isScheduled)}
                  content={isScheduled ? "Disable" : "Enable"}
                  color={isScheduled ? "green" : "blue"}
                  icon={isScheduled ? "check" : "plus"}
                  labelPosition="left"
                  style={{ float: 'right' }}
                />
                { isScheduled ? (
                  <Button 
                    onClick={() => manualSurveyStart(templateShiftKey)}
                    style={{ float: 'right', clear: 'both', marginTop: '3px' }}
                    content={"Manual Survey"}
                    size="mini"
                    compact
                    // color={isScheduled ? "green" : "blue"}
                    disabled={!shiftList[shiftId].assignedEmployees.length}
                    icon="send"
                    labelPosition="left"
                  />
                ) : null}
                </React.Fragment>
              )}
              </List.Content> */}
              <List.Icon name="conversation" size="large"/>
              <List.Content>
                <List.Header>
                  {shiftList[shiftId].shiftName}
                  <div className="shiftDescriptionWrapper">
                    <Label size="mini" style={{ marginLeft: '3px' }} image basic>
                      <Icon name='stopwatch' />
                      Last Triggered ({promptType.charAt(0).toUpperCase() + promptType.slice(1)})
                      <Label.Detail>{moment(new Date(promptTime._seconds*1000)).format("dddd MMMM Do YYYY, h:mm A z")}</Label.Detail>
                    </Label>
                    {/* <Label size="mini" style={{ marginLeft: '3px' }} image basic>
                      <Icon name='stopwatch' />
                      Starts
                      <Label.Detail>{moment(shiftList[shiftId].shiftStart,"HH:mm").tz(shiftList[shiftId].shiftTimezone).format("h:mm A z")}</Label.Detail>
                    </Label>
                    { shiftList[shiftId].shiftSendAuto ? (
                      <Label size="mini" color={isScheduled ? "green" : null} style={{ marginLeft: '3px' }} image basic={isScheduled ? false : true}>
                        <Icon name='send' />
                        Autosend
                        <Label.Detail>{moment(shiftList[shiftId].shiftStart,"HH:mm").tz(shiftList[shiftId].shiftTimezone).subtract(+shiftList[shiftId].shiftNotificationTime, 'minutes').format("h:mm A z")}</Label.Detail>
                      </Label> 
                  ) : null }*/}
                  </div>
                </List.Header>
                <List.Description>

                  {atRisk.length ? (
                    <Label color="orange" size="mini"><Icon name='exclamation triangle' />{atRisk.length} at Risk</Label>
                  ) : null}

                  {noResponse.length - atRisk.length - clearedForWork.length ? (
                    <Label color={null} size="mini"><Icon name='circle question' />{noResponse.length - atRisk.length - clearedForWork.length} No Response</Label>
                  ) : null}

                  {clearedForWork.length ? (
                    <Label color="green" size="mini"><Icon name='check' />{clearedForWork.length} Clear for Work</Label>
                  ) : null}

                  {/* <div className="shiftDescriptionWrapper">
                    <Label size="mini" style={{ marginLeft: '3px' }} image basic>
                      <Icon name='stopwatch' />
                      Starts
                      <Label.Detail>{moment(shiftList[shiftId].shiftStart,"HH:mm").tz(shiftList[shiftId].shiftTimezone).format("h:mm A z")}</Label.Detail>
                    </Label>
                    { shiftList[shiftId].shiftSendAuto ? (
                      <Label size="mini" color={isScheduled ? "green" : null} style={{ marginLeft: '3px' }} image basic={isScheduled ? false : true}>
                        <Icon name='send' />
                        Autosend
                        <Label.Detail>{moment(shiftList[shiftId].shiftStart,"HH:mm").tz(shiftList[shiftId].shiftTimezone).subtract(+shiftList[shiftId].shiftNotificationTime, 'minutes').format("h:mm A z")}</Label.Detail>
                      </Label>
                  ) : null }
                  </div> */}

                </List.Description>
                <List.Description>{`${shiftList[shiftId].assignedEmployees.length || "No"} assigned employees`}</List.Description>
              </List.Content>
            </List.Item>
          )
        }) }
      </List>
    );
  }

  renderShiftList = () => {
    const { currentShifts } = this.props;
    if (!currentShifts) {
      return null;
    } else {
      const currentShiftIds = Object.keys(currentShifts);
      return (
        <React.Fragment>
        {currentShiftIds.length ? (
          this.renderShiftSublist(currentShifts)
        ) : null}
        </React.Fragment>
      );
    }
  }

  render() {
    const { shiftsLoading, shiftsErrors, surveysErrors, surveysLoading } = this.props;

    return (
      <Container>

        <Header as="h1">
          <Header.Content>Manage Responses</Header.Content>
        </Header>

        <Segment.Group>
          <Segment>
            <Header>
              <Header.Content>Survey Responses</Header.Content>
            </Header>
          </Segment>

          <Segment loading={shiftsLoading || surveysLoading}>
            <Header>
              <Header.Content>COVID-19 Self-Screening SMS Survey <Label color="black">Automated</Label></Header.Content>
              <Header.Subheader>Enable automated surveys for each shift as needed</Header.Subheader>
            </Header>
            {this.renderShiftList()}
          </Segment>

          {/* <Segment secondary>
            <Button color="green" 
              content={
                <span>Save Changes
                <Label circular color="red" className="buttonCircleNotification">1</Label>
                </span>
              } 
              onClick={() => initiateManualSurvey()}
              labelPosition="left" icon="check" 
            />
          </Segment> */}
        </Segment.Group>

        {
          shiftsErrors ? (
            <Message error>
              <Message.Header>Could not load shifts.</Message.Header>
              <Message.Content>Refresh, or contact hello@SalusSMS.com for support.</Message.Content>
            </Message>
          ) : null
        }

        {
          surveysErrors ? (
            <Message error>
              <Message.Header>Could not load surveys.</Message.Header>
              <Message.Content>Refresh, or contact hello@SalusSMS.com for support.</Message.Content>
            </Message>
          ) : null
        }
        
      </Container>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  view: selectCurrentViewWithData,
  currentCompany: selectCurrentCompany,
  currentShifts: selectCurrentShifts,
  shiftsErrors: selectShiftsErrors,
  shiftsLoading: selectShiftsLoading,
  surveysLoading: selectSurveysLoading,
  currentSurveys: selectCurrentSurveys,
  surveysErrors: selectSurveysErrors,
  currentPrompts: selectCurrentPrompts,
  currentResponses: selectCurrentResponses
});

const mapDispatchToProps = dispatch => ({
  setCurrentView: (newView, viewData) => dispatch(setCurrentView(newView, viewData)),
  getShiftsStart: ({ currentCompany }) => dispatch(getShiftsStart({ currentCompany })),
  toggleSurveyStart: ({ templateId, shiftId, nextStatus }) => dispatch(toggleSurveyStart({ templateId, shiftId, nextStatus })),
  getSurveysStart: () => dispatch(getSurveysStart()),
  manualSurveyStart: (surveyId) => dispatch(manualSurveyStart(surveyId)),
  getPromptsStart: () => dispatch(getPromptsStart())
});

export default connect(mapStateToProps, mapDispatchToProps)(ResponseList);